
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profession/[slug]",
      function () {
        return require("private-next-pages/profession/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profession/[slug]"])
      });
    }
  